import * as React from "react";
import { forwardRef } from "react";
const SvgMultivendorV2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M13.5 18.7812L12 18.5L4.81571 17.1529C4.34274 17.0643 4 16.6513 4 16.1701V15V14C4 13.4477 4.44772 13 5 13H19C19.5523 13 20 13.4477 20 14V15V18.7951C20 19.4212 19.4311 19.8933 18.8157 19.7779L18 19.625L17.5 19.5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.5176 19.9671C13.8035 21.0341 14.9002 21.6672 15.9671 21.3813C17.0341 21.0955 17.6672 19.9988 17.3813 18.9319C17.0955 17.8649 15.9988 17.2318 14.9319 17.5176C13.8649 17.8035 13.2318 18.9002 13.5176 19.9671Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 21L7 18",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9 12H12",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17 8L17 13",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 8L7 13",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20 4V7.38197C20 8.12535 19.2177 8.60884 18.5528 8.27639L17.491 7.7455C17.1852 7.59259 16.8225 7.60652 16.5293 7.78243L15.0145 8.6913C14.6978 8.88131 14.3022 8.88131 13.9855 8.6913L12.5145 7.8087C12.1978 7.61869 11.8022 7.61869 11.4855 7.8087L10.0145 8.6913C9.69781 8.88131 9.30219 8.88131 8.9855 8.6913L7.47072 7.78243C7.17754 7.60652 6.81481 7.59259 6.50901 7.7455L5.44721 8.27639C4.78231 8.60884 4 8.12535 4 7.38197V4H20Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgMultivendorV2);
export default ForwardRef;
